import React from "react";
import {
  Box,
  Container,
  Grid,
  Typography,
  Link,
  Divider,
  Paper,
} from "@mui/material";
import LocationMap from "./LocationMap";

const contactItems = [
  {
    title: "Phone",
    value: "+966 57 526 8281",
    href: "tel:+966575268281",
  },
  {
    title: "Email",
    value: "info@zencon-sa.com",
    href: "mailto:info@zencon-sa.com",
  },
  {
    title: "Address",
    value: "Rd 183, Support Industrial Area Phase1, Road 120A, Al Jubail 35717",
  },
  {
    title: "Business Hours",
    value: `Sunday - Thursday \n 8:00 AM - 5:00 PM`,
  },
];

export default function ContactSection() {
  return (
    <Box>
      {/* Contact Grid */}
      <Grid container spacing={4}>
        {contactItems.map((item, index) => (
          <Grid item size={{ xs: 12, sm: 6 }} key={index}>
            <Box
              sx={{
                transition: "0.3s ease",
                "&:hover": {
                  transform: "translateY(-4px)",
                },
              }}
            >
              <Typography
                sx={{
                  fontWeight: 800,
                  color: "#0755c9",
                  fontSize: { xs: "1rem", md: "1.4rem" },
                  mb: 1,
                }}
              >
                {item.title}:
              </Typography>

              <Link
                href={item?.href}
                underline="none"
                sx={{
                  color: "#15a05d",
                  fontSize: { xs: "0.8rem", md: "1.2rem" },
                  fontWeight: 500,
                  transition: "0.3s ease",
                  whiteSpace: "pre-line",

                  "&:hover": {
                    color: "#0d7f49",
                    letterSpacing: "0.4px",
                  },
                }}
              >
                {item.value}
              </Link>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
